export default "__VITE_ASSET__b3a45689__"